import { cva as e } from "class-variance-authority";
// src/design/forms/number-input/style.ts
var t = e("flex w-full flex-col gap-0.5 text-foreground", {
	variants: { disabled: {
		true: "opacity-90 grayscale",
		false: ""
	} },
	defaultVariants: { disabled: !1 }
}), n = e("text-xs font-medium text-foreground", {
	variants: {
		required: {
			true: "after:content-[\"*\"] after:ml-0.5 after:text-destructive",
			false: ""
		},
		disabled: {
			true: "",
			false: ""
		}
	},
	defaultVariants: {
		required: !1,
		disabled: !1
	}
}), r = e("relative isolate"), i = e([
	"w-full bg-transparent outline-hidden bg-white",
	"font-medium tabular-nums text-foreground placeholder:font-normal placeholder:text-muted-foreground/60",
	"border border-border rounded-md",
	"focus-visible:z-10 focus-visible:outline-hidden focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
	"data-[invalid]:border-destructive data-[invalid]:focus-visible:border-destructive data-[invalid]:focus-visible:ring-destructive/50",
	"disabled:cursor-not-allowed disabled:opacity-100"
], {
	variants: { size: {
		sm: "h-8 px-3 pr-8 text-sm",
		md: "h-11 px-3.5 pr-8 text-sm",
		lg: "h-12 px-4 pr-9 text-base"
	} },
	defaultVariants: { size: "sm" }
}), a = e([
	"absolute right-px top-px bottom-px z-10 overflow-hidden",
	"flex flex-col",
	"w-6 border-l border-border rounded-r-sm"
], {
	variants: {
		buttonLayout: {
			horizontal: "flex-row w-12",
			vertical: ""
		},
		hideTriggers: {
			true: "hidden",
			false: ""
		}
	},
	defaultVariants: {
		buttonLayout: "vertical",
		hideTriggers: !1
	}
}), o = e([
	"inline-flex flex-1 items-center justify-center border-none bg-transparent",
	"text-foreground/80 select-none",
	"enabled:cursor-pointer enabled:hover:bg-muted enabled:active:bg-muted/80",
	"disabled:cursor-not-allowed disabled:text-muted-foreground",
	"focus-ring-inset",
	"[&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0"
], { variants: { hideTriggers: { true: "hidden" } } }), s = e("", {
	variants: { buttonLayout: {
		horizontal: "border-r border-border",
		vertical: "border-b border-border"
	} },
	defaultVariants: { buttonLayout: "horizontal" }
}), c = e([
	"absolute left-px top-px bottom-px z-10 inline-flex items-center justify-center",
	"w-10 text-foreground/80 select-none",
	"cursor-ew-resize",
	"[&>svg]:h-3 [&>svg]:w-3"
], {
	variants: { size: {
		sm: "w-10",
		md: "w-10",
		lg: "w-11"
	} },
	defaultVariants: { size: "sm" }
}), l = e("text-sm tabular-nums text-foreground"), u = e("text-xs text-muted-foreground"), d = e("text-xs text-destructive font-medium"), f = (e) => ({
	root: (e) => t(e),
	label: (e) => n(e),
	control: () => r(),
	input: () => i({ size: e?.size }),
	triggerGroup: () => a({
		buttonLayout: e?.buttonLayout,
		hideTriggers: e?.hideTriggers
	}),
	trigger: () => o({ hideTriggers: e?.hideTriggers }),
	incrementTrigger: () => s({ buttonLayout: e?.buttonLayout }),
	decrementTrigger: () => "",
	scrubber: () => c({ size: e?.size }),
	valueText: () => l(),
	helperText: () => u(),
	errorText: () => d()
});
export { r as controlStyles, d as errorTextStyles, f as getStyles, u as helperTextStyles, s as incrementTriggerStyles, i as inputStyles, n as labelStyles, t as rootStyles, c as scrubberStyles, a as triggerGroupStyles, o as triggerStyles, l as valueTextStyles };

//# sourceMappingURL=style.js.map